import React from "react";
import "./roadmap.css";

const Roadmap = () => {
  return (
    <section className="roadmap">
      <div className="roadmap-inner">
        <h1 className="roadmap-title">Roadmap</h1>
        <p className="roadmap-coming-soon">New roadmap coming soon...</p>
      </div>
    </section>
  );
};

export default Roadmap;
